import { Logo } from 'src/components/Logo'
import { getHomeUrl } from 'src/utils/url'

export function SlimLayout({ children }: { children: React.ReactNode }) {
    return (
        <div className="bg-[#3b4049] w-full flex flex-grow flex-col">
            {/* Home is served by Cloudflare Pages; full page load required. */}
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a className="relative top-4 left-4 flex flex-row w-fit" href={getHomeUrl()}>
                <Logo className="h-8 w-auto mr-2" />
                <span className="font-semibold text-xl text-white">Circuitly</span>
            </a>
            <div className="relative flex flex-col flex-grow w-full justify-center items-center px-4 my-8 md:my-0">
                <div className="relative bg-white shadow-2xl min-w-fit w-full sm:w-fit rounded-md px-6 sm:px-8 ">
                    <main className="flex flex-grow justify-center min-w-[310px] min-h-80">{children}</main>
                </div>
            </div>
        </div>
    )
}
